import CurrencyInput from "react-currency-input-field";
import { Box, Typography, useTheme } from "@mui/material";
import TextField from "@mui/material/TextField";
import { tokens } from "../../theme";
import useMediaQuery from "@mui/material/useMediaQuery";

import LoadingButton from "@mui/lab/LoadingButton";

import ProductsFromServer from "../select-products";

export const PixPay = ({ handlerChangeCurrency, value, handleStep, handleInputChangeProducts, productsSell, handleRemoveProduct }) => {
	const theme = useTheme();
	const colors = tokens(theme.palette.mode);
	const isNonMobile = useMediaQuery("(min-width: 800px)");
	

	return (
		<Box
			display="flex"
			justifyContent="center"
			alignItems="center"
			flexDirection="column"
			p="10px"
			sx={{
				gap: "20px",
				width: "100%",
				marginTop: "90px",
			}}
		>	
			<ProductsFromServer 
			handleInputChangeProducts={handleInputChangeProducts}
			productsSell={productsSell}
			handleRemoveProduct={handleRemoveProduct}
			/>
			<Typography variant="h3" color={colors.primary[100]}>
				Valor a Pagar:
			</Typography>
			{value > 0
				? <Typography variant="h2" color={colors.primary[100]}>
						{parseFloat(value).toLocaleString("pt-br", {
							style: "currency",
							currency: "BRL"
						})}
					</Typography>
				: <Typography variant="h2" color={colors.primary[100]}>
						R$ 0,00
					</Typography>}
			<CurrencyInput
				customInput={TextField}
				variant="outlined"
				label="Insira o valor caso seja diferente"
				maxLength="7"
				type="tel"
				id="input-example"
				name="input-name"
				placeholder="R$ "
				// defaultValue={1000}
				prefix="R$ "
				decimalsLimit={2}
				decimalSeparator=","
				groupSeparator="."
				// onValueChange={(value, name) => console.log(value, name)}
				onValueChange={(value, name) => handlerChangeCurrency(value)}
				sx={{
					width: isNonMobile ? "50%" : "100%",
					fontSize: "20px",
					backgroundColor: colors.pink[600],
					borderRadius: "4px",
					"& MuiInputBase-root.Mui-focused": {
						color: `${colors.grey[200]} !important`,
						fontWeight: "bold"
					},
					"& .MuiFormLabel-root.Mui-focused": {
						color: `${colors.grey[200]} !important`,
						fontWeight: "bold",
						fontSize: "12px"
					}
				}}
			/>
			<LoadingButton
				loading={false}
				type="submit"
				sx={{
					backgroundColor: colors.greenAccent[600],
					width: isNonMobile ? "50%" : "100%",
					borderRadius: "60px"
				}}
				variant="contained"
				disabled={!value || productsSell.length === 0}
				onClick={handleStep}
				// disabled={isValid}
			>
				Avançar
			</LoadingButton>
		</Box>
	);
};

export default PixPay;
